import React from "react";
import { useDispatch } from "react-redux";
import {
  FETCH_INVITATIONS,
  ACCEPT_INVITATION,
  REJECT_INVITATION,
} from "../../actions/InvitationsActions";
import {
  StyledInvitationCard,
  StyledHeader,
  StyledTitleContainer,
  StyledTitle,
  StyledIcon,
  StyledItemList,
  StyledItem,
  StyledButtons,
  StyledText,
  StyledSpan,
} from "./style";
import theme from "../../theme";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import arrow from "../../assets/svg/arrow-up-right.svg";
import CustomButton from "../common/button/CustomButton";

const InvitationList = ({invitationList}) => {
  const dispatch = useDispatch();
  
  const handleAccept = (invite) => {
    dispatch({
      type: ACCEPT_INVITATION,
      payload: {
        invitationId: invite.id,
        groupCartId: invite.groupCart?.id,
      },
      onSuccess: () => dispatch({ type: FETCH_INVITATIONS }), // refresh list
    });
  };


  const handleReject = (invite) => {
    dispatch({
      type: REJECT_INVITATION,
      payload: {
        invitationId: invite?.id,
        groupCartId: invite.groupCart?.id,
      },
      onSuccess: () => dispatch({ type: FETCH_INVITATIONS }),
    });
  };

  const buttonLabel = [
    {
      btnLabel: "Accept",
      color: "success",
      icon: <CheckIcon width={20} height={20} />,
      action: "accept",
    },
    {
      btnLabel: "Reject",
      color: "#ED7272",
      action: "reject",
      icon: <ClearIcon width={20} height={20} />,
    },
  ];

  return (
    <StyledInvitationCard>
      {/* Header */}
      <StyledHeader>
        <StyledTitleContainer>
          <StyledTitle>INVITATIONS</StyledTitle>
          <StyledIcon src={arrow} alt="Arrow Icon" />
        </StyledTitleContainer>
      </StyledHeader>

      {/* List of Invitations */}
      <StyledItemList>
          {invitationList?.map((invite, index) => (
            <StyledItem key={index}>

              <StyledText>
                You have invitation from
                <StyledSpan>{invite?.groupCart?.cart_name}</StyledSpan> by{" "}
                <StyledSpan>{invite?.invite_by?.name}</StyledSpan>
              </StyledText>
              <StyledButtons>
                {buttonLabel.map((lable) => (
                  <CustomButton
                    padding="3px 15px"
                    btntype="none"
                    variant="outlined"
                    fontSize={theme.typography.small.fontSize}
                    btnLabel={lable.btnLabel}
                    color={lable.color}
                    endIcon={lable.icon}
                    onClick={() => lable.action === "accept" ? handleAccept(invite) : handleReject(invite)}
                  />
                ))}
              </StyledButtons>
            </StyledItem>
          ))}
      </StyledItemList>
    </StyledInvitationCard>
  );
};

export default InvitationList;
